module.exports = __webpack_public_path__ + "static/img/5.0068181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/5.png
// module id = yk2A
// module chunks = 1